import { useQuery } from '@tanstack/react-query';
import { utilityDetailService } from '../services/utilityDetail.service';

export function useUtilityDetail(id: string) {
  const systemQuery = useQuery({
    queryKey: ['utility', 'detail', id],
    queryFn: () => utilityDetailService.getSystemDetail(id),
    enabled: !!id,
  });

  const componentsQuery = useQuery({
    queryKey: ['utility', 'components', id],
    queryFn: () => utilityDetailService.getSystemComponents(id),
    enabled: !!id,
  });

  return {
    system: systemQuery.data,
    components: componentsQuery.data || [],
    isLoading: systemQuery.isLoading || componentsQuery.isLoading,
  };
}
